import { useState, useEffect } from "react";
var PlatformEnum = /* @__PURE__ */ ((PlatformEnum2) => {
  PlatformEnum2["ANDROID"] = "Android";
  PlatformEnum2["IOS"] = "iOS";
  PlatformEnum2["WINDOWS"] = "Windows";
  PlatformEnum2["MAC"] = "Mac";
  PlatformEnum2["LINUX"] = "Linux";
  PlatformEnum2["UNKNOWN"] = "Unknown";
  return PlatformEnum2;
})(PlatformEnum || {});
const usePlatform = () => {
  const [platform, setPlatform] = useState(
    "Unknown"
    /* UNKNOWN */
  );
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/android/i.test(userAgent)) {
      setPlatform(
        "Android"
        /* ANDROID */
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      setPlatform(
        "iOS"
        /* IOS */
      );
    } else if (/Win/.test(navigator.platform)) {
      setPlatform(
        "Windows"
        /* WINDOWS */
      );
    } else if (/Mac/.test(navigator.platform)) {
      setPlatform(
        "Mac"
        /* MAC */
      );
    } else if (/Linux/.test(navigator.platform)) {
      setPlatform(
        "Linux"
        /* LINUX */
      );
    } else {
      setPlatform(
        "Unknown"
        /* UNKNOWN */
      );
    }
  }, []);
  return platform;
};
export {
  PlatformEnum,
  usePlatform
};
